export const CREATE_VEHICLE = 'CREATE_VEHICLE';
export const CREATE_VEHICLE_ERROR = 'CREATE_VEHICLE_ERROR';
export const CREATE_VEHICLE_REQUEST = 'CREATE_VEHICLE_REQUEST';
export const CREATE_VEHICLE_SUCCESS = 'CREATE_VEHICLE_SUCCESS';

export const DELETE_VEHICLE = 'DELETE_VEHICLE';
export const DELETE_VEHICLE_ERROR = 'DELETE_VEHICLE_ERROR';
export const DELETE_VEHICLE_REQUEST = 'DELETE_VEHICLE_REQUEST';
export const DELETE_VEHICLE_SUCCESS = 'DELETE_VEHICLE_SUCCESS';

export const EDIT_VEHICLE = 'EDIT_VEHICLE';
export const EDIT_VEHICLE_ERROR = 'EDIT_VEHICLE_ERROR';
export const EDIT_VEHICLE_REQUEST = 'EDIT_VEHICLE_REQUEST';
export const EDIT_VEHICLE_SUCCESS = 'EDIT_VEHICLE_SUCCESS';

export const GET_VEHICLE = 'GET_VEHICLE';
export const GET_VEHICLE_ERROR = 'GET_VEHICLE_ERROR';
export const GET_VEHICLE_REQUEST = 'GET_VEHICLE_REQUEST';
export const GET_VEHICLE_SUCCESS = 'GET_VEHICLE_SUCCESS';

export const GET_VEHICLES = 'GET_VEHICLES';
export const GET_VEHICLES_ERROR = 'GET_VEHICLES_ERROR';
export const GET_VEHICLES_REQUEST = 'GET_VEHICLES_REQUEST';
export const GET_VEHICLES_SUCCESS = 'GET_VEHICLES_SUCCESS';

export const SET_VEHICLE = 'SET_VEHICLE';
export const SET_VEHICLES = 'SET_VEHICLES';
